// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"40":"794d307d","71":"9a9c5e7f","218":"278ea27a","964":"9a201428"}[chunkId] + ".chunk.js");